import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ErrorBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${Spacing.S12};
  border-radius: ${BorderRadius.R8};
  background-color: ${Color.Red700};
  color: ${Color.White};
  word-wrap: break-word;
`

export const ErrorIconWrapper = styled.div`
  display: inline-flex;
  flex-shrink: 0;
  margin-right: ${Spacing.S8};
`
